import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { PartnerListInner } from './parts';

import { JSX } from 'react';
import styles from './partnerList.module.scss';

export type PartnerListProps = SliceComponentProps<Content.PartnerListSlice>;

const PartnerList = ({ slice }: PartnerListProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
      className={styles.section}
    >
      <PartnerListInner slice={slice} />
    </section>
  );
};

export default PartnerList;
